const routingModes = {
    ALL_TO_ALL: 'all_to_all',
    PAIRED: 'paired'
}

const routingModeItems = [{
    value: routingModes.ALL_TO_ALL,
    label: 'All to all'
}, {
    value: routingModes.PAIRED,
    label: 'Paired'
}]

const getRoutingMode = (routingMode) => {
    return routingMode === routingModes.PAIRED ? routingModes.PAIRED : routingModes.ALL_TO_ALL;
}

const getRoutingModeDisplay = (routingMode) => {
    return routingModeItems.find(item => item.value === getRoutingMode(routingMode))?.label;
}

export {
    routingModes,
    routingModeItems,
    getRoutingMode,
    getRoutingModeDisplay
}
